import React from 'react';
import { useNavigate } from 'react-router-dom';
import { all_routes } from '../../router/all_routes';
import Breadcrumb from '../../../core/common/Breadcrumb/breadcrumb';
import { useAuth } from '../../auth/AuthProvider';
import { t } from '../../../lang/index';

interface ContactInfo {
    label: string;
    value: string;
}

const ContactUs = () => {
    const { user } = useAuth();
    const navigate = useNavigate();
    const routes = all_routes;

    // Breadcrumb Data
    const breadcrumbs = [
        { label: t("contactUsSection.breadcrumb.home"), active: false, link: routes.home1 },
        { label: t("contactUsSection.breadcrumb.pages"), active: false },
        { label: t("contactUsSection.breadcrumb.contactUs"), active: true },
    ];

    // 👉 abre modal de login/registro
    const openRegisterModal = () => {
        const modalEl = document.getElementById('register-modal');
        if (modalEl) {
            const bootstrapModal = new (window as any).bootstrap.Modal(modalEl);
            bootstrapModal.show();
        }
    };

    const handleDashboardRedirect = () => {
        navigate(routes.userSupport);
    };

    // ✅ Pega o array de informações de contato do i18n
    const contactInfo: ContactInfo[] = t("contactUsSection.info") as unknown as ContactInfo[];

    return (
        <div>
            <Breadcrumb 
                title={t("contactUsSection.title")} 
                breadcrumbs={breadcrumbs} 
                backgroundClass="breadcrumb-bg-02" 
            />

            <div className="content">
                <div className="container">
                    <div className="row align-items-center row-gap-4">
                        {/* Coluna de informações */}
                        <div className="col-xl-7 col-lg-7">
                            <div className="mb-4 mb-lg-0">
                                <h2 className="mb-3">{t("contactUsSection.title")}</h2>
                                <p className="mb-4">{t("contactUsSection.description")}</p>

                                {contactInfo.map((item, index) => (
                                    <div key={index} className="border-bottom mb-4">
                                        <div className="d-flex align-items-center mb-4">
                                            <span className="avatar avatar-lg rounded-circle bg-light text-gray-6 me-2">
                                                <i className={`isax ${index === 0 ? "isax-sms5" : index === 1 ? "isax-call-calling5" : "isax-map-15"} fs-24`} />
                                            </span>
                                            <div>
                                                <p className="fs-14 mb-0">{item.label}</p>
                                                <h6 className="text-gray-6">{item.value}</h6>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>

                        {/* Coluna do Card de suporte */}
                        <div className="col-xl-5 col-lg-5">
                            <div className="card bg-light-200 shadow-none mb-0">
                                <div className="card-body">
                                    <h2 className="mb-3">{t("contactUsSection.supportCard.title")}</h2>
                                    <p className="text-gray-6 mb-4">
                                        {!user 
                                            ? t("contactUsSection.supportCard.textLoggedOut") 
                                            : t("contactUsSection.supportCard.textLoggedIn")
                                        }
                                    </p>

                                    {!user
                                        ? <button className="btn btn-primary" onClick={openRegisterModal}>
                                            {t("contactUsSection.supportCard.btnLoggedOut")}
                                          </button>
                                        : <button className="btn btn-primary" onClick={handleDashboardRedirect}>
                                            {t("contactUsSection.supportCard.btnLoggedIn")}
                                          </button>
                                    }
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Mapa */}
                    <div className="map-grid mt-4">
                        <iframe
                            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d49844.899997391425!2d-9.198975222575848!3d38.66482929377969!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xd19351c09ff1135%3A0xfca6dceb642ad67a!2sAlmada%2C%20Portugal!5e0!3m2!1spt-BR!2sbr!4v1759430773047!5m2!1spt-BR!2sbr"
                            width="100%"
                            height="400"
                            style={{ border: 0 }}
                            allowFullScreen
                            loading="lazy"
                        />
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ContactUs;
